import EventEmitter from './EventEmitter';
export default EventEmitter;
